import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BlockIcon } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NonIdealState } from '@/shared/components/NonIdealState';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const BlockedChatState: FC = () => {
  const theme = useAppTheme();

  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'components.blockedChatState'
  });

  // Todo: maybe use Empty card component
  return (
    <NonIdealState
      text={t('message')}
      image={
        <BlockIcon
          height={112}
          width={112}
          fill={theme.colors.onSurfaceVariant}
        />
      }
    />
  );
};
